import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FocusPayPaymentMethods } from "src/app/shared/models/DTO/focuspay.paymentMethods.dto";
import { FocusPayPaymentSession } from "src/app/shared/models/DTO/focuspay.paymentSession.dto";
import { FocuslinkService } from "./focuslink.service";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class PaymentService {
	paymentMethods: BehaviorSubject<FocusPayPaymentMethods> = new BehaviorSubject<FocusPayPaymentMethods>(new FocusPayPaymentMethods());
	paymentSession: BehaviorSubject<FocusPayPaymentSession> = new BehaviorSubject<FocusPayPaymentSession>(new FocusPayPaymentSession());
	paymentKey: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	constructor(private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	initPaymentService() {
		this.paymentMethodsGet();
	}

	async paymentMethodsGet() {
		const resp = await this.focuslink.paymentFocusPayPaymentMethods(this.venueService.venueKey);
		this.paymentMethods.next(new FocusPayPaymentMethods(resp));
		return this.paymentMethods;
	}

	async startSession(transactionAmount: number, checkKey: string) {
		this.paymentKey.next(this.venueService.app.uuidv4());
		const resp = await this.focuslink.paymentFocusPayCreateSession(this.venueService.venueKey, transactionAmount, checkKey, this.paymentKey.value);
		this.paymentSession.next(new FocusPayPaymentSession(resp));
		return this.paymentSession.value;
	}
}
